import { 
  Edit, 
  Box, 
  TextField, 
  FormControl, 
  FormControlLabel, 
  FormHelperText, 
  FormLabel, 
  Radio, 
  RadioGroup 
} from "@pankod/refine-mui";
import { Controller, useForm } from "@pankod/refine-react-hook-form";

export const NotificationEdit = () => {
  const {
    saveButtonProps,
    register,
    control,
    formState: { errors },
  } = useForm();

  return (
    <Edit saveButtonProps={saveButtonProps}>
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <TextField
          {...register("notification_id", {
            required: "This field is required",
          })}
          required
          error={!!(errors as any)?.notification_id}
          helperText={(errors as any)?.notification_id?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="number"
          label="Notification_id"
          name="notification_id"
          disabled
        />
        <TextField
          {...register("user_id", {
            required: "This field is required",
          })}
          required
          error={!!(errors as any)?.user_id}
          helperText={(errors as any)?.user_id?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="number"
          label="User_id"
          name="user_id"
        />
        <TextField
          {...register("title", {
            required: "This field is required",
          })}
          required
          error={!!(errors as any)?.title}
          helperText={(errors as any)?.title?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Title"
          name="title"
        />
        <TextField
          {...register("desc", {
            required: "This field is required",
          })}
          required
          error={!!(errors as any)?.desc}
          helperText={(errors as any)?.desc?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Desc"
          name="desc"
        />
        <Controller
          control={control}
          name="is_read"
          render={({ field: { onChange, value } }) => (
            <FormControl required error={!!(errors as any)?.is_read}>
              <FormLabel>Is_read</FormLabel>
              <RadioGroup
                row
                onChange={(_, value) => onChange(value === "true")}
                value={value}
              >
                <FormControlLabel
                  control={<Radio />}
                  label="True"
                  value={true}
                />
                <FormControlLabel
                  control={<Radio />}
                  label="False"
                  value={false}
                />
              </RadioGroup>
              <FormHelperText>
                {(errors as any)?.is_read?.message}
              </FormHelperText>
            </FormControl>
          )}
        />
      </Box>
    </Edit>
  );
};
